<!-- componente para recuperar contraseña -->
<template>
  <v-app id="backGND">
    <navBar />

    <v-card id="card_lost_pass" style="
        border-radius: 2em;
        margin-top: 7%;
        margin-left: 35%;
        width: 30%;
        background-color: rgba(19, 18, 17, 1);
      ">

    
      <v-container>
        <h2 style="color: white;">Recuperar contraseña</h2>
        <!-- Email -->
        
        <p style="margin-top: 1em" class="register-p">Introduce tu correo electrónico</p>
        <input class="register-input" type="email" v-model="email" />
        <span class="error_message"
          ><p>{{ error_email }}</p></span
        >

        <v-btn
          style="
            margin-bottom: 1em;
            margin-top: 2em;
            background-color: rgba(253, 246, 254, 0.96);
          "
          @click="forgetPassword()"
          >enviar</v-btn
        >

        <span class="error_message"
          ><p>{{ error_form }}</p></span
        >

        <span class="success_message"><p>{{success_message}}</p></span>

        <br />

        <!-- barra de progreso, mientras carga el proceso -->
        <div v-if="show_spinner" class="text-center">
          <v-progress-circular
            indeterminate
            :rotate="-90"
            :size="50"
            :width="5"
            color="#2E7D32"
          >
          </v-progress-circular>
        </div>
      </v-container>
    </v-card>
  </v-app>
</template>
<script>
import navBar from "@/components/navbar";
import firebase from "firebase";
export default {
    components: { navBar,},
    data() {
    return {
      email: "",
      error_email: "",
      error_form: "",
      success_message: "",
      show_spinner: false
    };
  },
  methods: {
    forgetPassword() {
      this.show_spinner = true
      this.error_form = ""
      this.error_email = ""
      this.success_message = ""
      var a = this.errorEmail()

      if(a){
        //enviar mail de cambiar password y mostrar mensaje de enviado en snackbar
        firebase
          .auth()
          .sendPasswordResetEmail(this.email)
          .then(() => {     
        
            this.success_message = "Verifica tu bandeja de entrada con las instrucciones para cambiar tu contraseña"

            setTimeout(() => {
                this.$router.push("/login");
                this.email = "";
            },5000)
          })
          //devolver el error con el snackbar  
          .catch((error) => {
            console.log(error);
            switch (error.code) {
              case "auth/user-not-found":
                
                this.error_form = "Correo no encontrado, verificar";
                break;
              
            }
        });
      }
      this.show_spinner = false
    },
    errorEmail() {
      if (this.email != "") {
        if (this.validEmail(this.email)) {
          this.error_email = "";
          return true;
        } else {
          this.error_email = "Teclear un correo válido.";
          return false;
        }
      } else {
        this.error_email = "El correo no puede estar vacío.";
        return false;
      }
    },
    validEmail: function (email) {
      var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      return re.test(email);
    },
  },
}
</script>
<style scoped>
#backGND {
  background-image: url("../assets/back_pricing.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}

.register-p{
  font-weight: 900; color: rgba(253, 246, 254, 0.96)
}

.register-input{
  outline: none; border-bottom: 2px solid white; width: 100%; color: white; text-align: center;
}

.error_message {
  font-weight: 900;
  font-size: 1.1em;
  color: red;
  text-align-last: center;
}
a {
  text-decoration: none;
}

.success_message{
  font-weight: 900;
  font-size: 1.1em;
  color: green;
  text-align-last: center;
}

@media screen and (max-width: 1024px) {
  #card_lost_pass {
    margin-left: 30% !important;
    width: 40% !important;
  }
}

@media screen and (max-width: 800px) {
  #card_lost_pass {
    margin-left: 25% !important;
    width: 50% !important;
  }
}

@media screen and (max-width: 600px) {
  #card_lost_pass {
    margin-left: 20% !important;
    width: 60% !important;
  }
}
</style>
</style>


// WEBPACK FOOTER //
// src/components/passrecover.vue